import { render, staticRenderFns } from "./IlamsizNafakaAlacakFormWizard.vue?vue&type=template&id=8446f382"
import script from "./IlamsizNafakaAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./IlamsizNafakaAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports